import { LoadingAndErrorHandler, PageErrorWithReload, Screen } from '../../components';
import { FC, useContext, useRef, useState } from 'react';
import { CurrentPlanProjectionsFormContent } from '../../components/CurrentPlanProjections/CurrentPlanProjectionsFormContent';
import { FormHandlingContext } from '../../context/FormHandlingContext';
import { IressAlert, IressCol, IressForm, IressRow, IressSkeleton, IressStack } from '@iress-oss/ids-components';
import { useNavigate } from 'react-router';
import { Nullable } from '@xplan-pension-switching/common';
import { usePageSearchParams } from '../../hooks';
import { Section } from '../../components/Section/Section';

const loadingPlaceholder =
    <IressStack gutter="lg">
        <IressRow gutter="lg">
            <IressCol span={{md: 12}}>
                <Section heading={'Review and adjust selected plans'}>
                    <IressSkeleton height="11rem" data-testid="placeholder-plan-projections-table" />
                </Section>
            </IressCol>
        </IressRow>
    </IressStack>;

export const CurrentPlanProjections: FC = () => {
    const { entityId, scenarioId } = usePageSearchParams();

    const { formReference } = useContext(FormHandlingContext);
    const [showAlert, setShowAlert] = useState(false);
    const navigate = useNavigate();
    const validationRef = useRef<Nullable<{ validateData: () => boolean }>>(null);
    const onSubmit = async () => {
        const allReviewed = validationRef.current?.validateData();
        setShowAlert(!allReviewed);
        if (!allReviewed) return;

        navigate({
            pathname: `/new-investments`,
            search: `?entityid=${entityId}&scenarioId=${scenarioId}`,
        });
    };

    return (
        <Screen title={'Current plan projections'} withSubheading withButtons>
            <LoadingAndErrorHandler
                LoadingComponentFallback={loadingPlaceholder}
                ErrorComponentFallback={<PageErrorWithReload />}
            >
                <IressForm
                    onSubmit={onSubmit}
                    ref={formReference}
                    mode={'onBlur'}
                    data-testid={'current-plan-projections-form'}
                >
                    <IressStack gutter={'md'}>
                        {showAlert && (
                            <IressAlert
                                data-testid={'current-plan-projections-error-summary'}
                                status={'danger'}
                                heading={'All plans must be reviewed'}
                            />
                        )}
                        <CurrentPlanProjectionsFormContent ref={validationRef} />
                    </IressStack>
                </IressForm>
            </LoadingAndErrorHandler>
        </Screen>
    );
};
